import { createSlice } from "@reduxjs/toolkit";
import instance from "../../api/api.js";

export const fectchCommandes = () => async (dispatch) => {
  try {
    const response = await instance.get("commandesAdmin");
    console.log("REPONSECOMMANDES", response);
    const dataFilterByFlagTrue = response.data.data.filter(
      (item) => item.flag === 1
    );
    console.log("dataFilterByFlagTrue", dataFilterByFlagTrue);
    dispatch(fetchCommandesFulfilled(dataFilterByFlagTrue.length));
  } catch (error) {
    console.log();
  }
};
export const removeFlagCommandes = (payload) => async (dispatch) => {
  try {
    const response = await instance.post("/updateFlagCommande/" + payload);
    console.log("REPONSECommandes", response);
    if (response.status === true) {
      dispatch(removeItem());
    }
  } catch (error) {
    console.log();
  }
};
export const commandeReducer = createSlice({
  name: "Commandes",
  initialState: { commande_length: null },
  reducers: {
    removeItem: (state) => {
      const nouveau_length = state.commande_length - 1;
      return { ...state, commande_length: nouveau_length };
    },
    fetchCommandesFulfilled: (state, action) => {
      state.status = true;
      state.commande_length = action.payload; // Met à jour state.commandes avec les données de l'API
    },
  },
});

export const { handleTotalNew, fetchCommandesFulfilled, removeItem } =
  commandeReducer.actions;
export default commandeReducer.reducer;
